<template>
    <div>
			<div ref="map_interactive_wrapper" class="map_interactive_wrapper">
				<div class="filter-container">
					<div class="row">
							<BCol cols="6" sm="6" md="6" class="d-none d-md-block text-left align-self-center">
								<h2 class="p-2 company-name">{{ currentPlayer.name }}</h2>
							</BCol>

							<BCol cols="12" sm="6" md="6" class="text-right align-self-center">
								<b-dropdown right class="p-2 d-md-block d-none" variant="primary" id="dropdown-1" text="Choose supplier">
										<b-dropdown-item v-for="(player) in players"
										:active="currentPlayer.name == player.name"
										:ref="`case_index_${player.index}`"
										:data-index="player.index"
										:id="kebabCase(player.name)"
										:key="kebabCase(player.name)"
										@click="updateMap(player)" >
												{{ player.name }}
										</b-dropdown-item>
								</b-dropdown>					
								
								
							</BCol>
							<BCol cols="12" sm="6" md="6" class="text-center align-self-center">
								<b-dropdown center class="p-2 d-md-none d-block" variant="primary" id="dropdown-1" text="Choose supplier">
										<b-dropdown-item v-for="(player) in players"
										:active="currentPlayer.name == player.name"
										:ref="`case_index_${player.index}`"
										:data-index="player.index"
										:id="kebabCase(player.name)"
										:key="kebabCase(player.name)"
										@click="updateMap(player)" >
												{{ player.name }}
										</b-dropdown-item>
								</b-dropdown>										
							</BCol>

					</div>							
				</div>
				<HeaderMap :initial-scale="currentScale" :initial-center="currentCenter"  :appointed-by="currentPlayer.selling_company_iso3" :serving-in="currentPlayer.intermediary_company_iso3" :final-destination="currentPlayer.final_buyer_iso3" />
				<div ref="source-div" class="source-div">
					<BRow>
						<BCol cols="6">
							<h5>Source: {{ currentPlayer.source }}</h5>
						</BCol>
						<BCol cols="6" class="text-right">
							<b-button variant="primary" v-if="!show_deal" @click="showFindings(show_deal)" class="p-1"><IconFolder/> Click to show the deal </b-button>
						</BCol>
					</BRow>
				</div>
				<div>
					<BRow class="justify-content-center narrative-container" ref="narrative-container">
						<BCol cols="12" sm="12" md="12" 
						class="text-center p-0">
							<div class="route-bar text-center justify-content-center">
								<h5 class="route-intermediaries">
									<div role="button" @click="showTransaction(currentPlayer.selling_company_iso3)" class="btn-company">
										<div>
												<span class="d-block seller">Supplier:</span>
												{{ currentPlayer.selling_company }} 	
												<span class="d-block">{{ translateIsoCountry(currentPlayer.selling_company_iso3) }}</span>
										</div>
									</div>
									<arrowRight class="m-3" />
									<div role="button" @click="showTransaction(currentPlayer.intermediary_company_iso3)" class="btn-company">
										<div>
											<span class="d-block intermediary">Intermediary company:</span>
											{{ currentPlayer.intermediary_company }} 
											<span class="d-block">
													{{ translateIsoCountry(currentPlayer.intermediary_company_iso3) }} 
											</span>
									</div>
									</div>
									<arrowRight class="m-3"  />											
									<div role="button" @click="showTransaction(currentPlayer.final_buyer_iso3)"  class="btn-company">
										<div>
											<span class="d-block buyer">Final buyer:</span>
											{{ currentPlayer.final_buyer }}
											<span class="d-block">
													{{ translateIsoCountry(currentPlayer.final_buyer_iso3) }}
											</span>
										</div>
									</div>
								</h5>
							</div>
						</BCol>
						<BCol cols="12" sm="12" md="12" 
						class="text-center text-content pt-3 pb-5">
							<div class="text-center justify-content-center pb-5" >
								<div class="btn-back text-left">
									<b-button variant="button" v-if="show_deal" @click="showFindings(show_deal)" class="p-1"><IconBack/> Back to the map </b-button>
								</div>
								<h5 class="mt-2">Size of the shipment</h5>
								<div class="narrative-card">
									{{ currentPlayer.size }}
								</div>
								<h5 class="mt-4">Details of the deal</h5>
								<div class="narrative-card" v-html="currentPlayer.narrative"></div>
								<div class="narrative-card mb-5" v-html="currentPlayer.response"></div>
								<div><h5 class="source_text">Source: {{ currentPlayer.source }}</h5></div>
								<div>
									<b-button variant="primary" v-if="show_deal" @click="showFindings(show_deal)" class="p-1"><IconBack/> Back to the map </b-button>
								</div>
							</div>
						</BCol>
					</BRow>
				</div>
			</div>
			
			<embeddable-footer>
				<template #sharing-button>
					<h2 class="title-interactive">{{ $t('appContent.title') }}</h2>
				</template>
			</embeddable-footer>
	</div>
</template>

<script>
    import utils from '@/mixins/utils'
    import {kebabCase, find} from 'lodash'
    import arrowRight from "@/components/icons/arrowRight"
    import HeaderMap from "@/components/HeaderMap"
    import IconFolder from "@/components/IconFolder"
    import IconBack from "@/components/IconBack"

    // import store from "../store";
    export default {
        name: 'Home',
        data() {
					return {
						index: 0,
						hasHeader: false,
						isAnimating: false,
						isMobile:false,
						cid: null,
						currentPlayer: {},
						currentCenter: [],
						currentScale: 0,
						show_deal: false
					}
        },
        mixins: [utils],
        components: {
            arrowRight,
            HeaderMap,
						IconFolder,
						IconBack
        },
        computed: {
					countries() {
						return require("@/data/countries.json")
					},
					players() {
						return this.$store.state.players.all
					}
        },
				watch: {
					currentCenter() {
						this.show_deal = false
					},
					show_deal(v) {
						if(!v)
							this.$refs['narrative-container'].classList.remove(`active`)
					}
				},
        methods: {
					kebabCase,
					updateMap(player) {
						if(player) {
							this.currentPlayer = player
							this.currentCenter = this.currentPlayer.center
							this.currentScale = this.currentPlayer.scale
						}
					},
					showTransaction(iso) {
						this.currentCenter = this.countries[iso]
						this.currentScale = 760
					},
					showFindings(v) {
						if(!v) {
							this.$refs['narrative-container'].classList.add(`active`)
							this.$refs['source-div'].classList.add(`active`)
						}							
						else {
							this.$refs['narrative-container'].classList.remove(`active`)
							this.$refs['source-div'].classList.remove(`active`)
						}

						this.show_deal = !v
					}
        },
        mounted() {
					this.currentPlayer = find(this.$store.state.players.all,[ 'index', '1'])
					this.currentCenter = this.currentPlayer.center
					this.currentScale = this.currentPlayer.scale
        }
    }

</script>


<style lang="scss">
    #app{
        position: relative;
        width: 100%;
				height: 100vh;
				overflow: hidden;
        scroll-behavior: smooth;
    }
    body {
        color: #000;
        &::-webkit-scrollbar,&::-webkit-scrollbar-track,&::-webkit-scrollbar-thumb {
            width: 0px;
        }
    }

    @media (min-width: 1465px) {
        .container, .container-sm, .container-md, .container-lg, .container-xl {
            max-width: 1400px;
        }
    }

		.embeddable-footer__brand {
			@media (max-width: 860px) {
				font-size: 0px !important;
			}
		}

		.source-div {
			position: absolute;
			bottom: 120px;
			padding: 10px;
			width: 100%;
			z-index: 99;
			transition: bottom .25s ease-in-out;

			&.active {
				bottom: -300px;
			}
			
			h5 {
				font-size: 12px !important;
				color: #fff;
			}
		}

		h5.source_text {
			font-size: 12px !important;
			margin-bottom: 15px;
		}

    .noselect {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .arrowBack {
        transform: rotate(180deg);
    }

    body.disable-scroll {
        overflow: hidden;

    }

		h2.title-interactive {
			padding: 0px 5px;
			font-size: 17px;
			color: #fff;
			flex-wrap: wrap;
			white-space: normal;
			margin: 0;

			@media (max-width: 725px) {
				font-size: 15px;
				text-align: center;
			}
		}

    .arrow-down-float {
        position: absolute;
        z-index: 9999;
        bottom: 75px;
        right: 5%;
        cursor: pointer;
    }
		
		.narrative-card {
			font-size: 18px;
			max-width: 480px;
			margin: 0 auto;
		}
		.narrative-container {
			position: relative;
			width: 100%;
			height: calc(100vh - 55px);
			margin: 0 ;
			transition: height .25s ease-in-out;
			z-index: 999;
			pointer-events: none;


			&.active {
				height: calc(100vh - 110px);
				overflow-y: auto;
				pointer-events: all;

				.text-content {
					height: auto;
					background: linear-gradient(0deg, black -26%, white 20%);
					pointer-events: all;
					opacity: 1;
				}
			}

			.text-content {
				opacity: 0.5;
				height: 125px;
				margin-top: auto;
				background: linear-gradient(0deg, black 27%, white 117%);
				transition: background 0.25s ease-in-out;
				transition: height .45s ease-in-out;

				@media (max-width: 725px) {
					height: 100px;
				}
			}

			.route-bar {
				background: #ffffffc2;
			}
		}

		.filter-container  {
			position: relative;
			width: 100%;
			z-index: 9999;
			background: var(--app-color-pink);
			margin: 0 !important;

			button {
				font-size: 18px;
			}

			.dropdown-item {
				font-size: 18px;
			}

			h2.company-name {
				font-size: 21px !important;
				font-weight: 600;
				color: #2b2a24 !important;
			}
		}


		.seller {
			background-color: var(--app-color-pink);
		}

		.intermediary {
			color: #fff;
			background-color: var(--app-color-blue);
		}

		.buyer {
			background-color: var(--app-color-green);
		}

		.btn-primary {
			font-size: 16px !important;
			@media (max-width: 725px) {
					font-size: 14px !important;
				}
		}

		.route-intermediaries {
			display: flex;
			align-items: center;
			text-align: center;
			justify-content: center;
			.btn-company {
				padding: 0 5px;
				display: flex;
				cursor: pointer;
				height: auto;
				flex-shrink: inherit;
				align-items: center;
				padding: 10px 5px;
				font-size: 16px;

				@media (max-width: 725px) {
					font-size: 14px;
				}

				&:hover {
						background: rgba(255, 255, 255, 0.182);
				}
			}

			span {
				font-weight: 400;
				font-size: 13px;
			}
		}

    .btn-read-more{
        background-color: transparent;
        color: var(--app-color-red);
        padding: .3rem 1.5rem;
        transition: opacity 300ms;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: fit-content;
        margin: 0 auto;
        font-size: 13px;
        &:hover,&:focus{
            opacity: .9;
        }
    }
    .btn-player{
        background-color: #7a2624;
        border-color: #7a2624;
        color: #fff;
        padding: .3rem 1.5rem;
        transition: opacity 300ms;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: fit-content;
        margin: 0 auto;
        font-size: 13px;
        &:hover,&:focus{
            opacity: .9;
            color: #fff;
        }
    }

</style>
